/**
 * This hook will return the notificationsStore, but more importantly
 * it will generate a listener that will allow the component to hook
 * into the notifications store `update` event.
 */
import { useContext, useEffect, useState } from "react";
import uuid from "uuid/v4";
import NotificationsStore from "../utils/NotificationsStore";
import { NotificationsStoreContext } from "../containers/App";

export default function useNotifications(): {
  checkNotifications: string;
  notificationsStore: NotificationsStore;
} {
  const notificationsStore = useContext(NotificationsStoreContext);
  const [checkNotifications, setCheckNotifications] = useState(uuid());

  // Trigger a re-render of this component if the notifications store emitted
  // an update.
  useEffect(() => {
    const notificationsListener = notificationsStore.on("update", () => {
      setCheckNotifications(uuid());
    });

    // Unsubscribe from the notifications store event when unmounting
    return () => {
      notificationsListener.unsubscribe();
    };
  }, []);

  return { checkNotifications, notificationsStore };
}
